import {
  DeviceProtocolDeviceMethodInterceptor, OperationDeviceMethodInterceptor
} from "@hybird/device/interceptor/beginSeal/core";
import {compositeAdbConnectSupport} from "@hybird/device/protocol/extension/AdbConnectSupport";

export const adbConnectSupport = compositeAdbConnectSupport;

export class AdbDeviceMethodInterceptor extends DeviceProtocolDeviceMethodInterceptor {
  async connect(proceed, self, params = {}) {
    return await proceed(params).then(async result => {
      await adbConnectSupport.connect().catch(e => {
        console.warn("连接adb异常", e);
      });

      return result;
    });
  }

  isSupport(deviceBeginSeal) {
    return adbConnectSupport.isSupport();
  }
}


export class AdbOperationDeviceMethodInterceptor extends OperationDeviceMethodInterceptor {

  async fileSync(proceed, self, params) {
    return await adbConnectSupport.downloadFiles(params);
  }

  async firmwareUpgrade(proceed, self, {
    type = 1, localCallback, path, data, success, complete, message, fail, timeout
  } = {}) {
    if (adbConnectSupport.connected) {
      if (type === 1) {
        const result = await adbConnectSupport.firmwareUpgrade(data);
        return proceed({
          type,
          data,
          localCallback: result.localCallback,
          path: result.path,
          success,
          complete,
          message,
          fail,
          timeout
        });
      } else if (type === 2) {
        const result = await adbConnectSupport.imageUpgrade(data);
        return proceed({
          type,
          data,
          localCallback: result.localCallback,
          path: result.path,
          success,
          complete,
          message,
          fail,
          timeout
        });
      }
    }


    return proceed({type, data, localCallback, path, success, complete, message, fail, timeout});
  }

  get order() {
    return super.order + 50;
  }

  isSupport(deviceBeginSeal) {
    return adbConnectSupport.isSupport();
  }
}